
import { TimerTypes } from '../constants/timerConstants';

const initialState = {
    opened: false,
    items: [],
    lastAction: undefined,
    changed: false,
};

export const timersReducer = (state = initialState, action) => {
    switch (action.type) {
        case TimerTypes.TOGGLE_TIMER:
            return {
                ...state,
                opened: !state.opened
            };

        case TimerTypes.UPDATE_TIMERS:
            return {
                ...state,
                items: [...action.timers],
                lastAction: action.action
            };
        
        case TimerTypes.MARK_TIMER_CHANGED:
            return {
                ...state,
                changed: action.state
            };


        
        default:
            return state;
    }
};